import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggingService } from '../shared/services/logging.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  constructor(private loggingService: LoggingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (event: any) => {
          if (event.url && event.body && event.body.errors && event.body.errors.length > 0) {
            this.loggingService.log(`HTTP ERROR: ${JSON.stringify(event.body)}`);
          }
        },
        (error: any) => {
          // An error has occurred
          if (error instanceof HttpErrorResponse && error.error && error.error.errors && error.url) {
            this.loggingService.log(`HTTP ERROR: ${JSON.stringify(error.error)}`);
          } else {
            this.loggingService.log(`HTTP ERROR: ${JSON.stringify(error.statusText)}`);
          }
        },
      ),
    );
  }
}
